var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecommendation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 124,
    viewBox: "0 0 94 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 53.7926,
    cy: 80.0561,
    r: 15.4147,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M44.491 92.6407L44.491 107.961L53.7926 104.678L62.5471 107.961V93.1879",
    stroke: "#0F0E0E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M53.7927 72.3491L55.2986 76.9836L55.5231 77.6745H56.2496H61.1226L57.1803 80.5388L56.5925 80.9658L56.817 81.6568L58.3228 86.2913L54.3805 83.427L53.7927 83L53.2049 83.427L49.2626 86.2913L50.7685 81.6568L50.993 80.9658L50.4052 80.5388L46.4629 77.6745H51.3358H52.0624L52.2869 76.9836L53.7927 72.3491Z",
    stroke: "#DA291C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 18",
    d: "M95.4709 116.263H11.0203V24.6783L29.0201 7.73724H95.4709V41.2081V116.263Z",
    stroke: "#0F0E0E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 96.4709,
    cy: 24.2462,
    r: 16.509,
    fill: "#DA291C",
    stroke: "#DA291C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 19",
    d: "M92.4809 22.4448L89.358 25.5678L86.3949 22.6047L95.9238 13.0758L106 23.1519L103.584 25.5678L100.461 22.4448L98.7539 20.7377V23.1519V35.2836H94.188V23.1519V20.7377L92.4809 22.4448Z",
    stroke: "white",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendation);
export default __webpack_public_path__ + "static/media/recommendation.b2d22033040967da1707420cc8fc7e1b.svg";
export { ForwardRef as ReactComponent };